import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import './IndustryPage.css';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../Dashboard/layout';
import { Headings } from '../RegisteredUsersList/ViewRegList';
import { Form } from 'react-bootstrap';

const AddIndustryPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    status: '',
  });
const navigate = useNavigate();
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.name) {
      errors.name = 'Name is required';
    }
    if (!formData.status) {
      errors.status = 'Status is required';
    }
    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate the form
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      console.log('Form has errors, not submitting');
      Swal.fire('Error', 'Please fill in all required fields', 'error');
      return;
    }

    try {
      const form = new FormData();
      form.append('name', formData.name);
      form.append('status', formData.status);

      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}api/admin/industries`,
        form,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (res.data.status === 0) {
        Swal.fire({
          title: 'Error',
          text: 'Industry name already exists!',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      } else {
        Swal.fire({
          title: 'Success',
          text: 'New Industry Added Successfully!',
          icon: 'success',
          confirmButtonText: 'OK',
        });
        // Navigate to another page (e.g., ViewRegList) after success
          navigate("/industries "); // Uncomment and use navigate properly
      }
    } catch (error) {
      console.error('Error submitting data', error);

      if (error.response) {
        Swal.fire(
          'Error',
          error.response.data.message || 'Something went wrong. Please try again.',
          'error'
        );
      } else if (error.request) {
        Swal.fire('Error', 'Unable to reach the server. Please check your internet connection.', 'error');
      } else {
        Swal.fire('Error', 'Something went wrong. Please try again.', 'error');
      }
    }
  };

  return (
    <DashboardLayout>

      <section className="MainDivSec">

        <Headings headspan="Add" hedtext=" Industry " />

        <div className="AdduserFormDiv">

          <Form onSubmit={handleSubmit}>

            <div className="FormGroupDiv">
              <label htmlFor="name">Name:</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Enter industry name"
                required
              />
            </div>

            <div className="FormGroupDiv">
              <label htmlFor="status">Status:</label>
              <select
                id="status"
                name="status"
                value={formData.status}
                onChange={handleInputChange}
                required
              >
                <option value="">Select status</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
            </div>

            <div className="SubMit">
              <button type="submit" >Add Industry</button>
            </div>


          </Form>



        </div>

      </section>

     
    </DashboardLayout>
  );
};

export default AddIndustryPage;
